module.exports = __webpack_public_path__ + "img/10.2d6a9f05.png";